import React, { useCallback, useRef } from 'react';
import { useGridFilter } from "ag-grid-react";
import { Box, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { formatAssigneeValue } from '../../helper/helpersSubModule';

export function CustomTextNumberFilter(params) {
    const refInput = useRef(null);
    const { model, onModelChange, getValue, colDef } = params;

    const doesFilterPass = useCallback((params) => {
        const { node } = params;
        const filterText = model?.filter?.[0]?.toLowerCase() || '';  // Get the filter text
        const filterType = model?.type || 'includes';  // Get the filter type
        const value = getValue(node)?.toString()?.toLowerCase();

        if (value === null || ((value === undefined  || value === "") && filterType !== 'blank' )) {
            return false;
        }
        if (colDef.type === 'number') {
          if(value === "" && filterType === "blank"){
            return true;
          }
            if (!isNaN(value) && !isNaN(parseFloat(value))) {
                return filterConditionMatches(value, filterText, filterType);
            }
            return false;
        } else if (colDef.type === "multi dimensional value") {
            try {
              
              if((value === undefined || value === "") && filterType === 'blank'){
                return true;
              }
              else{
                const multiDimensionalValue = JSON.parse(value);
                return multiDimensionalValue.some((item) => {
                    const propValueStr = item?.propvalue?.toString();
                    return (
                        item?.propvalue &&  // Ensure propvalue is not empty
                        (filterConditionMatches(propValueStr?.toLowerCase(), filterText, filterType, colDef)
                           )
                    );
                });
              }
            } catch (error) {
                console.error("Error parsing multi-dimensional value:", error);
                return false;
            }
        } else {
            return filterConditionMatches(value, filterText, filterType,colDef);
        }
    }, [model]);

    const filterConditionMatches = (value, filterText, filterType, colDef) => {

      let formattedValue;
      if ((value === undefined || value === null || value === "") && filterType === 'blank') {
        return true;
      }
      if (colDef?.type === 'person' || colDef?.type === "Assignee") {
        formattedValue = formatAssigneeValue(value);

      }
        const parsedValue = colDef?.type === 'person' || colDef?.type === "Assignee" ? JSON.parse(formattedValue) : null;
        
        
        // Convert filterText to lowercase for case-insensitive comparison
        const lowerFilterText = filterText.toLowerCase();
      
        const checkCondition = (lowerValue) => {
          let value = lowerValue.trim();
          switch (filterType) {
            case 'equals':
              return value === lowerFilterText;
      
            case 'startsWith':
              return value.startsWith(lowerFilterText);
      
            case 'endsWith':
              return value.endsWith(lowerFilterText);
      
            case 'contains':
            case 'includes': // Including both 'contains' and 'includes'
              return value.includes(lowerFilterText);
      
            case 'notContains':
              return !value.includes(lowerFilterText);
      
            case 'notEqual':
              return value !== lowerFilterText;
      
            case 'blank':
              return value === "" || value === undefined;
      
            case 'notBlank':
              return value !== "" && value !== undefined;
      
            default:
              return false; // Return false for unrecognized filter types
          }
        };
      
        if (parsedValue && filterType !== 'equals' && filterType !== 'notEqual' && filterType !== 'blank') {
          return parsedValue.some(person => checkCondition(person.username.toLowerCase()));
        } else {
          const lowerValue = value?.toLowerCase() || value;
          return checkCondition(lowerValue);
        }
      };
      

    const afterGuiAttached = useCallback((params) => {
        if (!params || !params.suppressFocus) {
            refInput.current.focus();
        }
    }, []);

    // register filter handlers with the grid
    useGridFilter({
        doesFilterPass,
        afterGuiAttached,
    });

    const debouncedOnModelChange = (value) => {
        const newModel = value === '' ? null : { filter: [value], type: 'includes' };  // default filter type
        onModelChange(newModel);
        // Force a refresh of the grid immediately after updating the model
        setTimeout(() => {
            if (params.api) {
                params.api.refreshCells({ force: true });
                params.api.redrawRows();
            }
        }, 0);
    };

    return (
        <Box sx={{ maxHeight: "250px", overflowY: "auto" }}>
            <Box sx={{ margin: 0, padding: "0.5rem", display: 'flex', alignItems: "center", justifyContent: "center", width: "100%", gap: "0.5rem" }}>
                <input
                    ref={refInput}
                    type="text"
                    value={model?.filter?.[0] || ''}
                    onChange={({ target: { value } }) => {
                        debouncedOnModelChange(value);
                        refInput.current.focus();
                    }}
                    placeholder="Search Values"
                    style={{ width: "100%", padding: "0.25rem" }}
                />
                <Tooltip title="Clear Filter">
                    <ClearIcon sx={{ fontSize: "1rem", cursor: "pointer" }} onClick={() => { onModelChange(null); refInput.current.focus(); }} />
                </Tooltip>
            </Box>
        </Box>
    );
}
